import type { DocumentRevision } from '@/entities/Document';
import { DocumentRevisionStatus } from '@/shared/lib';
import { Stage } from '@/shared/lib';

// ==================== MOCK DOCUMENTS ====================

export const MOCK_DOCUMENTS: DocumentRevision[] = [
  {
    id: 1,
    documentId: 1,
    revision: 1,
    effectiveDate: '2024-01-15',
    status: DocumentRevisionStatus.APPROVED,
    stage: Stage.COMPLETED,
    docUrl: null,
    document: {
      id: 1,
      name: 'Document test 17',
      prefix: 'MQ17.1',
      requestDate: '2024-01-10',
      type: 'PROCEDURE',
    },
    createdAt: '2024-01-10T09:00:00Z',
    updatedAt: '2024-01-12T10:30:00Z',
    approvalDate: '2024-01-12',
    approvedAt: '2024-01-12T10:30:00Z',
    validityDate: '2025-01-15',
    physicalLocations: [],
    changelogEntries: [],
  },
  {
    id: 2,
    documentId: 2,
    revision: 2,
    effectiveDate: '2024-02-20',
    status: DocumentRevisionStatus.PENDING_APPROVAL,
    stage: Stage.IN_PROGRESS,
    docUrl: null,
    document: {
      id: 2,
      name: 'Document test 13',
      prefix: 'MQ13.1',
      requestDate: '2024-02-15',
      type: 'PROCEDURE',
    },
    createdAt: '2024-02-15T14:00:00Z',
    updatedAt: '2024-02-15T14:00:00Z',
    approvalDate: '',
    approvedAt: '',
    validityDate: '2025-02-20',
    physicalLocations: [],
    changelogEntries: [],
  },
  {
    id: 3,
    documentId: 3,
    revision: 1,
    effectiveDate: '2024-03-10',
    status: DocumentRevisionStatus.PENDING_APPROVAL,
    stage: Stage.IN_PROGRESS,
    docUrl: null,
    document: {
      id: 3,
      name: 'Document test 25',
      prefix: 'MQ25.1',
      requestDate: '2024-03-05',
      type: 'NORM',
    },
    createdAt: '2024-03-05T11:00:00Z',
    updatedAt: '2024-03-05T11:00:00Z',
    approvalDate: '',
    approvedAt: '',
    validityDate: '2025-03-10',
    physicalLocations: [],
    changelogEntries: [],
  },
  {
    id: 4,
    documentId: 4,
    revision: 3,
    effectiveDate: '2024-04-05',
    status: DocumentRevisionStatus.APPROVED,
    stage: Stage.COMPLETED,
    docUrl: null,
    document: {
      id: 4,
      name: 'Document test 21',
      prefix: 'MQ21.1',
      requestDate: '2024-04-01',
      type: 'INSTRUCTION',
    },
    createdAt: '2024-04-01T08:30:00Z',
    updatedAt: '2024-04-03T16:45:00Z',
    approvalDate: '2024-04-03',
    approvedAt: '2024-04-03T16:45:00Z',
    validityDate: '2025-04-05',
    physicalLocations: [],
    changelogEntries: [],
  },
  {
    id: 5,
    documentId: 5,
    revision: 2,
    effectiveDate: '2024-05-12',
    status: DocumentRevisionStatus.FAILED_APPROVAL,
    stage: Stage.COMPLETED,
    docUrl: null,
    document: {
      id: 5,
      name: '(DE) Document test 12',
      prefix: 'DA12.1',
      requestDate: '2024-05-08',
      type: 'FORM',
    },
    createdAt: '2024-05-08T10:15:00Z',
    updatedAt: '2024-05-10T13:20:00Z',
    approvalDate: '2024-05-10',
    approvedAt: '2024-05-10T13:20:00Z',
    validityDate: '2025-05-12',
    physicalLocations: [],
    changelogEntries: [],
  },
  {
    id: 6,
    documentId: 6,
    revision: 1,
    effectiveDate: '2024-06-15',
    status: DocumentRevisionStatus.APPROVED,
    stage: Stage.COMPLETED,
    docUrl: null,
    document: {
      id: 6,
      name: '(DE) Document test 24',
      prefix: 'DA24.1',
      requestDate: '2024-06-10',
      type: 'DOCUMENT',
    },
    createdAt: '2024-06-10T09:00:00Z',
    updatedAt: '2024-06-12T14:30:00Z',
    approvalDate: '2024-06-12',
    approvedAt: '2024-06-12T14:30:00Z',
    validityDate: '2025-06-15',
    physicalLocations: [],
    changelogEntries: [],
  },
  {
    id: 7,
    documentId: 7,
    revision: 1,
    effectiveDate: '2024-07-20',
    status: DocumentRevisionStatus.PENDING_APPROVAL,
    stage: Stage.IN_PROGRESS,
    docUrl: null,
    document: {
      id: 7,
      name: 'Document test 3',
      prefix: 'IT03.1',
      requestDate: '2024-07-15',
      type: 'INSTRUCTION',
    },
    createdAt: '2024-07-15T11:00:00Z',
    updatedAt: '2024-07-15T11:00:00Z',
    approvalDate: '',
    approvedAt: '',
    validityDate: '2025-07-20',
    physicalLocations: [],
    changelogEntries: [],
  },
];

// ==================== LISTING CONFIG ====================

export const DEFAULT_LISTAGEM_CONFIG = {
  allowMultipleSelection: false,
  showCheckboxes: false,
  showIcons: true,
  maxDepth: 3,
  autoExpandFirstLevel: true,
};

export const DEFAULT_NAVIGATION_CONFIG = {
  allowMultipleSelection: true,
  showCheckboxes: true,
  showIcons: true,
  maxDepth: 5,
  autoExpandFirstLevel: false,
};
